import styled from 'styled-components'

export const TableData = styled.td`
  padding: 10px 0;
`

export const TableAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`